import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import { Categorie } from '@mairistem/comptabilite';
import { isEmpty } from 'lodash';

export const getCategories = (searchQuery?: string) => request.get<unknown, TemplateRequestGet<Categorie>>(
  `/api/finances/comptabilite/tiers/categories${!isEmpty(searchQuery) ? `/search?q=${searchQuery}` : ''}`,
);

export const postCategorie = (categorie: Partial<Categorie>) => request.post<Partial<Categorie>, Categorie>(
  '/api/finances/comptabilite/tiers/categories',
  categorie,
);
